// преобразует дату из формата 'YYYY-MM-DD' в формат 'DD MonthName'
// convertDeliveryDate('2024-01-26') -> 26 января

export function formatDate(dateString: string) {
	const months = [
		'января',
		'февраля',
		'марта',
		'апреля',
		'мая',
		'июня',
		'июля',
		'августа',
		'сентября',
		'октября',
		'ноября',
		'декабря'
	]

	const date = new Date(dateString)
	const day = date.getDate()
	const month = date.getMonth()

	return `${day} ${months[month]}`
}
